export default __webpack_public_path__ + "static/media/instant-rebate.0d760edf.svg";